// extracted by mini-css-extract-plugin
export var modal = "_dr-0";